<div class="title" mat-dialog-title>Add Username & Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your theTradeDesk Account Manager to obtain the details
            below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>TTD Username</mat-label>
                <input matInput placeholder="Enter TTD Username" formControlName="username" data-cy="ttd-username-input">
                <mat-error
                    *ngIf="connectionForm.get('username').errors && (connectionForm.get('username').touched || connectionForm.get('username').dirty)">
                    Invalid TTD Username</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
                <mat-label>TTD Password</mat-label>
                <input type="password" matInput placeholder="Enter TTD Password" formControlName="password"
                    data-cy="ttd-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid TTD Password</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Partner ID</mat-label>
                <input matInput placeholder="Enter partner id" formControlName="partnerId" data-cy="ttd-parent-id-input">
                <mat-error
                    *ngIf="connectionForm.get('partnerId').errors && (connectionForm.get('partnerId').touched || connectionForm.get('partnerId').dirty)">
                    Invalid partner id</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
            data-cy="ttd-dialog-connect-source-btn">Connect Data Source</button>
    </div>
</div>